import { render, staticRenderFns } from "./WineProduct.vue?vue&type=template&id=2cc04ccd&"
import script from "./WineProduct.vue?vue&type=script&lang=js&"
export * from "./WineProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports